export default __webpack_public_path__ + "static/media/trophy.4f3346af.svg";